module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAmBAMAAAA2FaaYAAAALVBMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADBoCg+AAAADnRSTlMA5RslH9/p29kpK8+5LKig9dAAAABfSURBVBjTY4ABlh440/UFXDAuGC740AAuKEykIFMdXFCdkKAkXPDZBLhgJkxQAyHYl4UQXABj7stlQGMiFCC0IQxDCGeiCiOcg3AkkrAwkrABijDC84jAI1v4BVK0AAAT7Sc64j3EaAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/chevron-left-black.png
// module id = 216
// module chunks = 0